import {
  getAttrById,
  replaceUrlParam,
  getHtmlPlainText,
  isFieldAllEmpty,
  simpleDeepClone
} from "@/utils"
import { getSyetemModuleJson } from "@/utils/initEv.js"
import { fixComponent } from "@/utils/analysisTypeId"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
/**
 * 列表页插件
 */
class SubPage {
  constructor(vue) {
    this.context = vue
    this.request_prefix = this.context.request_prefix
    this.appId = this.context.$store.state.states.getDataPageIds.appId
    this.restDataUrl = "" // 请求数据的接口地址
    this.engineId = "" // 引擎实例id
    this.params = { // 请求数据的参数
      t: "", // 分类id
      p: 1, // 请求数据的页数
      sw: "", // 搜索关键字
      typeIds: [], // 多级筛选的分类ids
      relIds: [], // 多级筛选的关联ids
      isOr: false, // 多级筛选的关联关系
      groupTypeId: "", // 多级筛选的分类id
      sd: "", // 开始时间
      ed: "", // 结束时间
      sf: "", // 开始时间flag
      ef: "", // 结束时间flag
    }
    this.introduction = "" // 分类简介内容
    this.restUrl // 分类数据
    this.appNameStr = {}
    this.subPage = JSON.parse(
      window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.context.request_prefix)
    )
    this.showBreadCrumbs = this.subPage.listPageSetting.showBreadCrumbs // 显示面包屑
    this.showNavMenu = this.subPage.listPageSetting.showNavMenu // 显示导航
    this.showSearchComponent = this.subPage.listPageSetting.showSearchComponent // 显示列表页搜索
    // 需要根据当前多级导航选中的节点类型，决定显示内容
    this.showDataGrid = true // 显示数据列表
    this.showIntroduction = true // 显示简介
    this.oldTypeId = "" // 记录上一次 选中的分类id
    this.defaultModuleId = "0ff11d4d1b5b2111ee1abc352b5e251c9164" // 默认列表样式id
    this.allDataGridStyleList = [] // 非默认数据列表样式
    this.typeClassifyFlag = false // 是否是点击分类，切换列表数据
  }
  async init() {
    // 先获取分类数据
    await this.initClassifyData()
    // 初始化组件
    this.context.$eventBus.$on("subPage-component-init", msg => {
      this.typeClassifyFlag = false
      if (typeof msg.typeId !== "undefined") {
        let generalDataTypesItem = this.findCurrentNavMenuData(this.restUrl.data.data.generalDataTypes, msg.typeId)
        if (generalDataTypesItem) {
          generalDataTypesItem = JSON.parse(JSON.stringify(generalDataTypesItem))
          const { showType, introduction } = generalDataTypesItem
          this.controlShowComponentType(showType)
          this.introduction = introduction
          this.getAssembleClassifylData(generalDataTypesItem)
        }
        this.oldTypeId = this.params.t
        this.params.t = msg.typeId
        this.typeClassifyFlag = true
      }
      if (typeof msg.pageNum !== "undefined") {
        this.params.p = msg.pageNum
      }
      if (typeof msg.sw !== "undefined") {
        this.params.sw = msg.sw
      }
      if (typeof msg.typeIds !== "undefined") {
        this.params.typeIds = msg.typeIds
      }
      if (typeof msg.relIds !== "undefined") {
        this.params.relIds = msg.relIds
      }
      if (typeof msg.isOr !== "undefined") {
        this.params.isOr = msg.isOr
      }
      if (typeof msg.groupTypeId !== "undefined") {
        this.params.groupTypeId = msg.groupTypeId
      }
      if (typeof msg.dateVal !== "undefined") {
        this.params.sf = msg.dateVal[0]
        this.params.ef = msg.dateVal[1]
        this.params.sd = msg.dateVal[2]
        this.params.ed = msg.dateVal[3]
      }
      if (Array.isArray(msg.type)) {
        msg.type.forEach(item => {
          const [shape, businessId] = item.split("_")
          switch (shape) {
            case "cxNoteEditor":
              this.initIntroductionData(shape + "_" + businessId)
              break
            case "cxNavMenuVertical":
              this.initNavMenuData(shape + "_" + businessId)
              break
            case "cxBreadCrumbs":
              this.initBreadCrumbsData(shape + "_" + businessId)
              break
            case "cxMultiFilter":
              this.initMultiFilterData(shape + "_" + businessId)
              break
            case "cxDataGrid":
              this.initDataGrid(shape + "_" + businessId)
              break
            case "cxDatePicker":
              this.initCxDatePickerData(shape + "_" + businessId)
              break
            case "cxCalendar":
              this.initCxCalendarData(shape + "_" + businessId)
              break
            case "cxSearch":
              this.initSeachData(shape + "_" + businessId)
              break
          }
        })
      } else {
        const [shape, businessId] = msg.type.split("_")
        switch (shape) {
          case "cxNoteEditor":
            this.initIntroductionData(shape + "_" + businessId)
            break
          case "cxNavMenuVertical":
            this.initNavMenuData(shape + "_" + businessId)
            break
          case "cxBreadCrumbs":
            this.initBreadCrumbsData(shape + "_" + businessId)
            break
          case "cxMultiFilter":
            this.initMultiFilterData(shape + "_" + businessId)
            break
          case "cxDataGrid":
            this.initDataGrid(shape + "_" + businessId)
            break
          case "cxDatePicker":
            this.initCxDatePickerData(shape + "_" + businessId)
            break
          case "cxCalendar":
            this.initCxCalendarData(shape + "_" + businessId)
            break
          case "cxSearch":
            this.initSeachData(shape + "_" + businessId)
            break
        }
      }
    })
  }
  async initClassifyData() {
    const { pageId, wfwfid, websiteId } = this.context.$store.state.states.getDataPageIds
    const { restUrl } = await getAppointCacheData.call(this.context, pageId, wfwfid, websiteId, this.appId)
    if (restUrl && restUrl.data && restUrl.data.data && restUrl.data.data.engineInstance) {
      this.restDataUrl = restUrl.data.data.restDataUrl
      const name =
        getHtmlPlainText(restUrl.data.data.engineInstance.appName) ||
        getHtmlPlainText(restUrl.data.data.engineInstance.name)
      this.context.$store.commit("states/changeSubPageName", name)
      this.setNameToClassify([{}], name)
    }
    this.restUrl = restUrl
    this.engineId = restUrl?.data?.data?.engineInstance?.publicId
    // 当前分类下的第一个分类的id
    let navMenuData,
      targetData = []
    navMenuData = restUrl.data.data.generalDataTypes
    this.recursiveFindDataTypesExtend(navMenuData, targetData)
    console.log("recursiveFindDataTypesExtend", this.allDataGridStyleList)
    this.oldTypeId = navMenuData[0]?.publicId
    this.params.t = navMenuData[0]?.publicId
    // 请求数据的url组装
    this.restDataUrl = this.restDataUrl.replace("typeId=", "t=").replace("engineInstanceId=", "e=")
    this.restDataUrl = replaceUrlParam(this.restDataUrl, "t", this.params.t)
    const { showType, introduction } = navMenuData[0]
    this.introduction = introduction
    this.controlShowComponentType(showType)
    await this.initClassifyDataGridStyle()
  }
  initCxDatePickerData(key) {
    // 初始化日期选择器组件
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initSubPageDatePickerData(this)
    }
  }
  initCxCalendarData(selectedDates, selectedDateMap) {
    Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
      if (key.indexOf("cxCalendar") !== -1) {
        this.context.$subPageEvent.contexts[key].initSubPageCalendarData(selectedDates, selectedDateMap, this)
      }
    })
  }
  initCxPaginationData(totalRecords, pageSize) {
    Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
      if (key.indexOf("cxPagination") !== -1) {
        this.context.$subPageEvent.contexts[key].initSubPagePaginationData(totalRecords, pageSize, this)
      }
    })
  }
  // 初始化breadCrumbs面包屑组件
  initBreadCrumbsData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initSubPageBreadCrumbsData(this)
    }
  }
  // 初始化多级导航组件
  initNavMenuData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initSubPageNavMenuData(this)
    }
  }
  // 初始化多级筛选组件
  initMultiFilterData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initSubPageMultiFilterData(this)
    }
  }
  // 更新简介区域数据
  initIntroductionData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initSubPageIntroductionData(this)
    }
  }
  // 初始化数据列表组件
  initDataGrid(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      if (this.typeClassifyFlag) {
        this.getDataByModuleId(this.context.$subPageEvent.contexts[key])
      }
      this.context.$subPageEvent.contexts[key].initSubPageDataGridData(this)
    }
  }
  // 初始化搜索组件
  initSeachData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initSubPageSearchData(this)
    }
  }
  // 初始化列表组件的不同样式
  async initClassifyDataGridStyle() {
    if (this.allDataGridStyleList.length === 0) return
    for (const key of Object.keys(this.context.$subPageEvent.contexts)) {
      if (key.indexOf("cxDataGrid") !== -1) {
        const dataGridInstance = this.context.$subPageEvent.contexts[key]
        // 如果dataGridInstance.options包含的storeOptions的属性长度
        if (dataGridInstance.options.storeOptions) continue
        // TODO 需要考虑后续增加的分类样式，需要判断样式是否已经存在
        let options = {}
        options["default"] = {
          ...dataGridInstance.options
        }
        for (const item of this.allDataGridStyleList) {
          const _attribute = await getSyetemModuleJson(item.moduleId)
          let temp = simpleDeepClone(_attribute)
          // 新增标识，区分是分类带来的数据列表组件，还是默认的
          temp.options.isClassifyDataGrid = true
          if (temp.shape === "emptyLayoutComponent") {
            temp.options.pluginName = ['dataGridPlugin']
            temp.options.appId = ""
            temp.options.encId = ""
            temp.options.moduleId = ""
            temp.options.publicId = ""
            temp.options.typeId = ""
            temp.options.componentTypeName = ""
            temp.options.componentTypeId = ""
            temp.options.engineInstanceAppId = ""
            temp.options.engineInstanceId = ""
            // 头部和底部边栏以及其中的组件默认不显示
            temp.options.titleOptions[0].isShow = false
            temp.options.titleOptions[1].isShow = false
            temp.options.titleOptions[2].isShow = false
            temp.options.titleOptions[3].isShow = false
            for (let i = 0; i < temp.options.titleOptions.length; i++) {
              if (temp.options.titleOptions[i].elementOptions.length > 0) {
                const elementOptions = temp.options.titleOptions[i].elementOptions
                for (let j = 0; j < elementOptions.length; j++) {
                  elementOptions[j].isShow = false
                }
              }
            }
            delete temp.options.myFetchParam
          }
          options[item.publicId] = {
            ...temp.options
          }
        }
        const data = {
          ...dataGridInstance.myid,
          options: options
        }
        console.log("initClassifyDataGridStyle", options)
        this.context.$store.dispatch(this.context.request_prefix + "/initStoreOptions", data)
      }
    }
  }
  // 递归找到数据分类层级
  recursiveFindDataTypes(navMenuData, targetData) {
    for (let key in navMenuData) {
      targetData.push({
        label: navMenuData[key].name,
        value: navMenuData[key].publicId,
        iconUrl: navMenuData[key].iconUrl,
        children: []
      })
      if (typeof navMenuData[key].subGeneralDataTypes == "object") {
        this.recursiveFindDataTypes(navMenuData[key].subGeneralDataTypes, targetData[key].children)
      }
    }
  }
  // 递归找到数据分类层级，并判断是否存在其他分类样式
  recursiveFindDataTypesExtend(navMenuData, targetData) {
    for (let key in navMenuData) {
      if (this.defaultModuleId !== navMenuData[key].moduleId) {
        this.allDataGridStyleList.push({
          moduleId: navMenuData[key].moduleId,
          publicId: navMenuData[key].publicId,
        })
      }
      targetData.push({
        label: navMenuData[key].name,
        value: navMenuData[key].publicId,
        iconUrl: navMenuData[key].iconUrl,
        children: []
      })
      if (typeof navMenuData[key].subGeneralDataTypes == "object") {
        this.recursiveFindDataTypesExtend(navMenuData[key].subGeneralDataTypes, targetData[key].children)
      }
    }
  }
  setNameToClassify(result, name) {
    const appName = name || "图文"
    const componentShape = fixComponent("appName", appName)
    let str = {}
    str.componentShape = componentShape
    str.value = "" + appName
    str.key = "应用名称"
    result[0].appName = str
    this.appNameStr = str
    window.localStorage.setItem(`classifyDetailData-` + this.appId, JSON.stringify(result))
  }
  // 组装当前分类的详情数据
  async getAssembleClassifylData(generalDataTypesItem) {
    // 获取当前分类的详情数据
    let _result = generalDataTypesItem ? [generalDataTypesItem] : []
    Object.keys(_result).forEach(key => {
      Object.keys(_result[key]).forEach(dataItemKey => {
        // 保留viewNum、name、updateTime字段
        if (dataItemKey === "viewNum" || dataItemKey === "name" || dataItemKey === "insertTime") {
          const componentShape = ["cxText", "cxButton"]
          let str = {}
          str.componentShape = componentShape
          str.value = "" + _result[key][dataItemKey]
          if (dataItemKey === "viewNum") str.key = "浏览量"
          if (dataItemKey === "name") str.key = "分类名称"
          if (dataItemKey === "insertTime") str.key = "分类发布时间"
          _result[key][dataItemKey] = str
          return
        }
        if (isNaN(dataItemKey)) {
          delete _result[key][dataItemKey]
        } else {
          if (isFieldAllEmpty(_result, dataItemKey)) {
            delete _result[key][dataItemKey]
          } else {
            const componentShape = fixComponent(dataItemKey, _result[key][dataItemKey].value)
            _result[key][dataItemKey].component_shape = componentShape
          }
        }
      })
      _result[key].appName = this.appNameStr
    })
    window.localStorage.setItem(`classifyDetailData-` + this.appId, JSON.stringify(_result))
  }
  // 需要根据当前多级导航选中的节点类型，控制数据列表，还是简介组件
  controlShowComponentType(showType) {
    switch (showType) {
      case 0:
      case 1: // 列表
        this.showDataGrid = true
        this.showIntroduction = false
        break
      case 2: // 简介
        this.showDataGrid = false
        this.showIntroduction = true
        break
      case 3: // 简介+列表
        this.showDataGrid = true
        this.showIntroduction = true
        break
      case 4: // 简介+分类列表
        this.showDataGrid = true
        this.showIntroduction = true
        break
    }
  }
  findCurrentNavMenuData(generalDataTypes, value) {
    let result = { value: undefined, parent: null }
    this.findCurrentNavMenuDataHandle(generalDataTypes, value, result, parent = null)
    return result.value
  }
  // 根据多级导航的选中publicId找到当前节点的数据
  findCurrentNavMenuDataHandle(generalDataTypes, value, result, parent) {
    for (let i = 0; i < generalDataTypes.length; i++) {
      if (generalDataTypes[i].publicId === value) {
        result.value = generalDataTypes[i]
        result.parent = parent
        return
      } else {
        if (generalDataTypes[i].subGeneralDataTypes.length > 0) {
          this.findCurrentNavMenuDataHandle(generalDataTypes[i].subGeneralDataTypes, value, result, generalDataTypes[i])
        }
      }
    }
  }
  // 根据当前选中分类id，判断是否存在其他分类样式
  getDataByModuleId(dataGridInstance) {
    if (this.allDataGridStyleList.length === 0) return
    const oldTypeId = this.oldTypeId
    const newTypeId = this.params.t
    const old_classify = dataGridInstance.options.storeOptions.hasOwnProperty(oldTypeId) ? oldTypeId : "default"
    const new_classify = dataGridInstance.options.storeOptions.hasOwnProperty(newTypeId) ? newTypeId : "default"
    const old_innerElement = dataGridInstance.options.innerElement
    if (old_classify === new_classify) {
      return
    }
    // 先将原dataGridInstance.options的内容备份到dataGridInstance.options.storeOptions中
    if (oldTypeId) {
      const temp = simpleDeepClone(dataGridInstance.options)
      delete temp.storeOptions
      const data = {
        ...dataGridInstance.myid,
        classify: old_classify,
        options: temp
      }
      this.context.$store.dispatch(this.context.request_prefix + "/changeStoreOptionsNew", data)
    }
    // 需要将storeOptions中的数据进行初始化
    if (newTypeId) {
      const _attribute = dataGridInstance.options.storeOptions[new_classify]
      let temp = simpleDeepClone(_attribute)
      if (dataGridInstance.options.hasOwnProperty("storeOptions")) {
        // 需要保留该组件的storeOptions
        temp.storeOptions = dataGridInstance.options.storeOptions
      }
      if (dataGridInstance.options.hasOwnProperty("path")) {
        // 需要保留该组件的storeOptions
        temp.path = dataGridInstance.options.path
      }
      if (dataGridInstance.options.hasOwnProperty("businessId")) {
        // 需要保留该组件的storeOptions
        temp.businessId = dataGridInstance.options.businessId
      }
      const data = {
        ...dataGridInstance.myid,
        options: temp.options || temp
      }
      this.context.$store.dispatch(this.context.request_prefix + "/changeAllOptions", data)
    }
    const new_innerElement = dataGridInstance.options.innerElement
    if (old_innerElement !== new_innerElement) {
      // 由于在此处完成了样式内容的切换，需要清理掉
      this.context.$subPageEvent.removeContext(dataGridInstance.options.businessId, "cxDataGrid")
    }
  }
}
export default {
  methods: {
    subPagePlugin() {
      const subPage = new SubPage(this)
      subPage.init()
    }
  }
}
